import React, { useState } from 'react';
import '../styles/DonationNote.css';

type NoteTapeColor = 'sage' | 'terracotta' | 'ochre';
type TapeSide = 'left' | 'right';

const TAPE_COLORS: Record<NoteTapeColor, string> = {
  sage: 'rgba(122,139,95,.5)',
  terracotta: 'rgba(194,90,58,.5)',
  ochre: 'rgba(198,140,59,.5)',
};

interface DonationNoteProps {
  kind: string;
  title: string;
  figures: string;
  caption?: string;
  handNote?: string;
  tapeColor?: NoteTapeColor;
  tapeSide?: TapeSide;
  rotation?: number;
  copyValue?: string;
}

interface NoteStyle extends React.CSSProperties {
  '--rot'?: string;
  '--tape-bg'?: string;
}

const DonationNote: React.FC<DonationNoteProps> = ({
  kind,
  title,
  figures,
  caption,
  handNote,
  tapeColor = 'sage',
  tapeSide = 'left',
  rotation = -1.25,
  copyValue,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const text = (copyValue ?? title ?? '').toString().replace(/\s+/g, ' ').trim();
    if (!text || typeof navigator === 'undefined' || !navigator.clipboard) return;
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      // swallow — react-expert PHASE 3 will wire a toast notification
    }
  };

  const style: NoteStyle = {
    '--rot': `${rotation}deg`,
    '--tape-bg': TAPE_COLORS[tapeColor],
  };

  return (
    <div className={`note note--tape-${tapeSide}`} style={style}>
      <button
        type="button"
        className="note__copy"
        onClick={handleCopy}
        aria-label={`Copiar ${title}`}
      >
        {copied ? 'copiado' : 'copiar'}
      </button>
      <div className="note__kind">{kind}</div>
      <h3 className="note__title">{title}</h3>
      <div className="note__figures">{figures}</div>
      {caption && <div className="note__caption">{caption}</div>}
      {handNote && <span className="note__hand">{handNote}</span>}
    </div>
  );
};

export default DonationNote;
